<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.subject : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">
      
      <div class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
          { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
        ]"> 
        <div class="md-content md-tabs-content md-theme-default">
          <div class="md-tabs-container">
            <div id="tab-active" class="md-tab">
              <div class="md-card md-layout-item md-small-size-100">
                <!-- View/Edit Case Template -->
                <CustomCaseTemplateConfigForm :recordData="recordData" :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :headerColor="headerColor"></CustomCaseTemplateConfigForm>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>

    <div v-else class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]"> 
      <div class="md-content md-tabs-content md-theme-default">
        <div class="md-tabs-container">
          <div id="tab-active" class="md-tab">
            <div class="md-card md-layout-item md-small-size-100">
              <!-- Add Case Template -->
              <CustomCaseTemplateConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :headerColor="headerColor"></CustomCaseTemplateConfigForm>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import Page from '@/mixins/Page';

  // Form validations
  import { required, numeric, minLength, email } from "vuelidate/lib/validators";
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as queries_custom from '@/graphql/queries_custom';

  export default {
    name: "casetemplates",
    mixins: [Record, Page],
    data() {
      return {
        workflowCaseTempList: [],
        incrWorkflowCaseTempList: [],
        reservedNameValidatorTimeoutId: null,
        isFirstTimeReservedNameCheck: true,
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'caseTemplateUpdatedById',
          updatedByTaskFieldName: 'taskUpdatedById',
          updatedByTaskStepFieldName: 'taskStepUpdatedById',
          responseFieldName: 'getCaseTemplate',
          actions: {
            save: 'createCaseTemplate',
            view: 'editCaseTemplate',
            edit: 'editCaseTemplate',
            new: 'newCaseTemplate',
            update: 'updateCaseTemplate',
            delete: 'deleteCaseTemplate',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":6,"h":18,"i":"0"}},
          },
          listPath: "/casetemplates",
          headerIcon: 'list_alt',
          objectName: 'CaseTemplate',
          objectNamePlural: 'CaseTemplates',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: {label: "ID", type: "id", slot: 'basic'},
            subject: {label: "Subject", type: "text", slot: 'basic', uniqueErrorMessage: 'Can not use this name as it is reserved.'},
            internal: {label: "Internal", type: "switch", slot: 'basic'},
            priority: {label: "Priority", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            origin: {label: "Origin", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            type: {label: "Type", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            status: {label: "Status", type: "select", slot: 'basic', options: [], optionType: 'enum'},
            caseTemplateTeamId: {label: "Team", type: "autocomplete", slot: "basic",
              data: [],
              searchTerm: "",
              options: [],
              linkBase: '#/teams/',
              setVal: (val) => {
                this.$v.form.caseTemplateTeamId.$model = val;
              },
              select: (c) => {(($this) => {
                $this.setVal(c.id);
                $this.searchTerm = c.name;
              })(this.formConfig.fields.caseTemplateTeamId)},
              hasValidation: true,
              isLazyLoadEnabled: true,
              lazyLoadListQueryId: 'searchTeams',
              lazyLoadResponseFieldName: 'searchTeams',
              lazyLoadSearchableFields: ['name'],
              // change: (search) => {(($this) => {
              //   const data = $this.data;
              //   $this.options = new Promise(resolve => {
              //     window.setTimeout(() => {
              //       if (!search) {
              //         $this.setVal("");
              //         $this.searchTerm = "";
              //         resolve(data)
              //       } else {
              //         const term = search.toLowerCase();
              //         let result = data.filter(({ name }) => name.toLowerCase() === term);
              //         if (result.length) {
              //           $this.select(result[0]);
              //         } else {
              //           $this.setVal("");
              //           $this.searchTerm = "";
              //         }
              //         resolve(data.filter(({ name }) => name.toLowerCase().includes(term)));
              //       }
              //     }, 100)
              //   })
              // })(this.formConfig.fields.caseTemplateTeamId)}
            },
            isCompleteInOrder: {label: 'Complete In Order', type: 'switch', slot: 'basic' },        
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          subject: "",
          internal: false,
          priority: "",
          origin: "",
          type: "",
          status: "",
          caseTemplateTeamId: "",
          isCompleteInOrder: false,
        }
      }
    },
    validations() {
      return {
        form: {
          id: {},
          subject: {required, minLength: minLength(3),
            async isUnique(value) {
              if (value.trim().length < 3) {
                return true;
              }
              const timeoutInterval = this.isFirstTimeReservedNameCheck ? 0 : 3000;
              this.isFirstTimeReservedNameCheck = false;
              clearTimeout(this.reservedNameValidatorTimeoutId);
              return new Promise(async (resolve, reject) => {
                this.reservedNameValidatorTimeoutId = setTimeout(async () => {
                  const valueTrimmed = value.trim();
                  const index = this.workflowCaseTempList.findIndex(_item => {
                    return _item.subject.toLowerCase() == valueTrimmed.toLowerCase();
                  });
                  if (-1 === index) {
                    return resolve(true);
                  }else if(this.recordData && this.recordData.hasWorkflow){
                    return resolve(true);
                  }
                  return reject(false);
                }, timeoutInterval);
              });
            }                   
          },
          internal: {},
          priority: {},
          origin: {},
          type: {required},
          status: {},
          caseTemplateTeamId: {
            isValid: this.isCaseTemplateTeamIdValid,
          },
          isCompleteInOrder: {},
        }
      }
    },
    async mounted() {
      this.loadCaseTemplateList();
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;

        let enumFields = {
          'origin': 'listCaseOriginEnum',
          'status': 'listCaseStatusEnum',
          'priority': 'listCasePriorityEnum',
          'type': 'listCaseTypeEnum',
        }

        this.loadTeamList(data);
        this.$loopo(enumFields, (source, field) => {
          // Update the options for each field
          (($this) => {
            let options = [];
            this.$loopo(data[source].enumValues, (value) => {
              options.push({name: value.name.replace(/_/g, ' '), id: value.name});
            });
            $this.options = options;

            // EDIT MODE - Select the current option if one exists.
            if (this.recordData && this.recordData[field]) {
              this.$v.form[field].$model = this.recordData[field];
            }
          })(this.formConfig.fields[field]);
        });
      },
      loadTeamList(data) {
          //Update the listTeams auto-complete
        (($this) => {
          //$this.data = data.listTeams.items;
          $this.data = [];
          if (this.recordData && this.recordData.team) {
            $this.searchTerm = this.recordData.team.name;
            this.form.caseTemplateTeamId = this.recordData.team.id;
          } else {
            if (this.$route.query.caseTemplateTeamId) {
              this.$v.form.caseTemplateTeamId.$model = this.$route.query.caseTemplateTeamId;
              /** try to find the company name */
              let matchingIndex = $this.data.findIndex(
                item => item.id === this.form.caseTemplateTeamId
              );
              if (matchingIndex >= 0) {
                $this.searchTerm = $this.data[matchingIndex].name;
              }
            }
          }
        })(this.formConfig.fields.caseTemplateTeamId);
      },
      async loadCaseTemplateList() {
        let params = {
          limit:999,
        };
        params.filter = {hasWorkflow: {eq: true}}
        let response = null;
        let error = null;
        let haveData = true;
        let page = 0;
        while (haveData) {
          error = null;
          response = await API.graphql(graphqlOperation(queries_custom["searchCaseTemplatesHasWorkflows"], params))
          .catch(err => {
              error = err
              if(err.data.searchCaseTemplates){
                this.incrWorkflowCaseTempList = this.incrWorkflowCaseTempList.concat(err.data.searchCaseTemplates.items);
              }
              haveData = err.data.searchCaseTemplates && err.data.searchCaseTemplates.items.length === params.limit ? true : false;
              if(haveData){
                page++
                params.nextToken = params.limit * page
              }
          });
          if (!error) {
            if(response.data.searchCaseTemplates){
              this.incrWorkflowCaseTempList = this.incrWorkflowCaseTempList.concat(response.data.searchCaseTemplates.items);
            }
            haveData = response.data.searchCaseTemplates && response.data.searchCaseTemplates.items.length === params.limit ? true : false;
            if(haveData){
              page++
              params.nextToken = params.limit * page
            }
          }
        }
        this.workflowCaseTempList = this.incrWorkflowCaseTempList;
      },
      /**
       * Validate case team selection
       * @param {String} value the selected team ID
       * @returns {Promise}
       */
      async isCaseTemplateTeamIdValid(value) {
        // normalized value
        const valueNormalized = value.toString().trim();
        
        // current field
        const field = this.formConfig.fields.caseTemplateTeamId;
        
        // value is empty and there is no search term
        if (!valueNormalized && !field.searchTerm) {
          return true;
        }
        
        // clear existing timeout
        clearTimeout(field.timeoutId);
        
        // query name
        const queryName = 'getTeam';
        
        // run new validation
        return new Promise(async (resolve, reject) => {
          field.timeoutId = setTimeout(() => {
            API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
              .then(res => {
                const name = this.$reduce(res, `data.${queryName}.name`);
                if (name === field.searchTerm) {
                  return resolve(true);
                }
                return reject(false);
              })
              .catch(err => {
                return reject(false);
              })
          }, 500);
        });
      },

    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;
    .md-tab-nav-button.md-button {
        color: black !important;

        &.active {
          color: black !important;
          border-bottom: 2px solid black;
        }
      }
    }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

</style>
